import { render, staticRenderFns } from "./MyCp1.vue?vue&type=template&id=ec7acb1c&scoped=true&"
import script from "./MyCp1.vue?vue&type=script&lang=js&"
export * from "./MyCp1.vue?vue&type=script&lang=js&"
import style0 from "./MyCp1.vue?vue&type=style&index=0&id=ec7acb1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7acb1c",
  null
  
)

export default component.exports